import React from "react";
import {Button} from "@material-ui/core";
import {loadGoogleMaps} from "../../lib/googleMaps";

const DEFAULT_MAP_CENTER = {lat: 46.5632507, lng: 23.7843233}; // Turda

// Where the courier goes: a draggable pin (or click the map to move it).
// "Caută pe hartă" puts it on the typed street/number/city.
export default class AddressPinMap extends React.Component {
  state = {error: ''};
  container = React.createRef();
  map = null;
  maps = null;
  marker = null;

  componentDidMount() {
    loadGoogleMaps().then((maps) => {
      if (!this.container.current) {
        return;
      }
      this.maps = maps;
      const center = this.center();
      this.map = new maps.Map(this.container.current, {
        center,
        zoom: this.hasPin() ? 17 : 13,
        streetViewControl: false,
        mapTypeControl: false,
      });
      this.marker = new maps.Marker({position: center, map: this.hasPin() ? this.map : null, draggable: true});
      this.marker.addListener('dragend', () => this.moved(this.marker.getPosition()));
      this.map.addListener('click', (e) => this.moved(e.latLng));
    }).catch(() => this.setState({error: 'Harta nu s-a putut încărca.'}));
  }

  componentDidUpdate(prevProps) {
    if (this.marker && (prevProps.latitude !== this.props.latitude || prevProps.longitude !== this.props.longitude)) {
      const center = this.center();
      this.marker.setPosition(center);
      this.marker.setMap(this.hasPin() ? this.map : null);
    }
  }

  hasPin = () => !!(this.props.latitude && this.props.longitude);

  center = () => (this.hasPin()
    ? {lat: Number(this.props.latitude), lng: Number(this.props.longitude)}
    : DEFAULT_MAP_CENTER);

  moved = (latLng) => {
    this.setState({error: ''});
    this.props.onChange(latLng.lat(), latLng.lng());
  };

  locate = () => {
    if (!this.maps) {
      return;
    }
    const query = this.props.query();
    new this.maps.Geocoder().geocode({address: query, region: 'RO'}, (results, status) => {
      if (status !== 'OK' || !results?.length) {
        this.setState({error: 'Adresa nu a fost găsită. Mută pinul manual pe hartă.'});
        return;
      }
      const location = results[0].geometry.location;
      this.moved(location);
      this.map.setCenter(location);
      this.map.setZoom(17);
    });
  };

  render() {
    return (
      <div className="users-map-field">
        <div className="users-map-toolbar">
          <span className="settings-description">
            {this.hasPin() ? 'Trage pinul sau apasă pe hartă ca să-l muți.' : 'Apasă pe hartă unde se livrează.'}
          </span>
          <Button size="small" color="primary" onClick={this.locate}>Caută pe hartă</Button>
        </div>
        <div ref={this.container} className="users-map"/>
        {!!this.state.error && <div className="users-error-text">{this.state.error}</div>}
      </div>
    );
  }
}
